// extracted by mini-css-extract-plugin
export default {"container":"InputFile_container__C60fu","input":"InputFile_input__JFcHM","thumbContainer":"InputFile_thumbContainer__jv88E"};